<!--  -->
<template>
  <div class="mentor-theme">
    <zlr-modal v-model="isShow">
      <div class="mentor-theme-con">
        <h1>文书辅导常用主题</h1>
        <p>Kick Off / PS Brainstorm / Essay Brainstorm</p>
        <h1>个性化辅导常用主题</h1>
        <ul>
          <li>1. Undergraduate Academic Preparation: Course Selection / Maintaining GPA, etc;</li>
          <li>2. Field Knowledge Exploration: Key field insight information and more;</li>
          <li>3. Master of PhD? – Things to know to make well-informed decisions;</li>
          <li>4. Specific Program Info: Program Features / Admission Preferences, etc;</li>
          <li>5. Reference Letters: Recommender Selection / Drafts Editing, etc;</li>
          <li>6. Professional CV: Draft Editing / Important rules to follow when preparing your CV for grad school applications;</li>
          <li>7. Further brainstorming on PS/Essays;</li>
          <li>8. Strategy for getting off from Waiting List;</li>
          <li>9. Sound offer selection;</li>
          <li>10. Things to know to get internship / Summer Research opportunities;</li>
          <li>11. Career Orientation: Networking, interview, and other skills needed for successful start of your career</li>
        </ul>
        <Button @click="isShow=false">关闭</Button>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// componnets
import ZlrModal from '_c/modal/modal'
export default {
  name: 'mentor-application-mentor-theme',
  components: {
    ZlrModal
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    showHandle () {
      this.isShow = true
    }
  }
}
</script>
<style lang='less' scoped>
.mentor-theme {
  &-con {
    padding: 12px 0;
    width: 741px;
    margin: 0 auto;
  }
  h1 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-bottom: 12px;
  }
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-bottom: 40px;
  }
  ul {
    margin-bottom: 32px;
  }
  li {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }
  .ivu-btn-default {
    width: 96px;
    border: 1px solid @c-primary;
    border-radius: 2px;
    color: @c-primary;
    padding: 4px 15px;
  }
}
</style>
